import { Observable, from, map } from "rxjs";

import { services } from "@progressive-development/pd-spa-helper";
import type { IDatabaseProvider } from "@progressive-development/pd-provider-interfaces";
import type { wahl } from "@progressive-development/politik-model";

import { COL_PARTEI_SICHTEN, DB_SHARED } from "../../../config/collections.js";

/**
 * Die Sicht einer Partei — EIN Dokument aus der geteilten Datenbank
 * (FACHKONZEPT-parteien.md, Teil B 11): Sitze, Wahlergebnisse, Mitglieder
 * liegen denormalisiert vor; die App joint nicht. Fehlt das Dokument, ist die
 * Sicht `undefined` — die Seite zeigt dann den Kopf und sagt es.
 */
export class ParteienService {
  private get _shared(): IDatabaseProvider {
    const db = services.databaseNamed(DB_SHARED);
    if (!db) throw new Error("Keine geteilte Datenbank konfiguriert (provider-setup.ts).");
    return db;
  }

  public ladeSicht(slug: string): Observable<ParteiSichtErgebnis> {
    return from(this._shared.getDocument<wahl.ParteiSicht>(COL_PARTEI_SICHTEN, slug)).pipe(
      map((snap) => ({ fuer: slug, sicht: snap.exists ? snap.data : undefined })),
    );
  }
}

export interface ParteiSichtErgebnis {
  fuer: string;
  sicht?: wahl.ParteiSicht;
}

export const parteienService = new ParteienService();
